<template>
  <fragment>
    <!--LIST-->
    <td
      v-if="$store.state.app.showConfiguration"
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="sourcePermisos[index].all.checkboxConfigurationVer"
          hide-details
          class="my-1"
          @click="checkAllListBooking()"
        ></v-checkbox>
      </div>
    </td>
    <!--EDIT-->
    <td
      v-if="$store.state.app.showConfiguration"
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="sourcePermisos[index].all.checkboxConfigurationEdit"
          hide-details
          class="my-1"
          @click="checkAllEditBooking()"
        ></v-checkbox>
      </div>
    </td>
    <!--CREATE-->
    <td
      v-if="$store.state.app.showConfiguration"
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="sourcePermisos[index].all.checkboxConfigurationCreate"
          hide-details
          class="my-1"
          @click="checkAllCreateBooking()"
        ></v-checkbox>
      </div>
    </td>
    <!--DESTROY-->
    <td
      v-if="$store.state.app.showConfiguration"
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="sourcePermisos[index].all.checkboxConfigurationDelete"
          hide-details
          class="my-1"
          @click="checkAllDestroyBooking()"
        ></v-checkbox>
      </div>
    </td>
    <td
      :key="Math.random() * (index + 1)"
      style="min-width: 50px;"
    ></td>
  </fragment>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    index: {
      type: Number,
    },
  },
  computed: {
    ...mapState({
      sourcePermisos: state => state.app.sourcePermisos,
    }),
  },
  methods: {
    checkAllListBooking() {
      const { permisos } = this.sourcePermisos[this.index]
      this.$store.state.app.showConfiguration = false
      if (this.sourcePermisos[this.index].all.checkboxConfigurationVer) {
        this.sourcePermisos[this.index].permisos.push('config_general:list')
        this.sourcePermisos[this.index].permisos.push('perfil_afiliado:list')
        this.sourcePermisos[this.index].permisos.push('user_register:list')
        this.sourcePermisos[this.index].permisos.push('role:list')
        this.sourcePermisos[this.index].permisos.push('user:list')
        this.sourcePermisos[this.index].permisos.push('users_son:list')
        this.sourcePermisos[this.index].permisos.push('agente:list')
        this.sourcePermisos[this.index].permisos.push('newletters:list')
      } else {
        this.sourcePermisos[this.index].permisos = permisos.filter(
          e => e !== 'config_general:list'
            && e !== 'perfil_afiliado:list'
            && e !== 'user_register:list'
            && e !== 'role:list'
            && e !== 'user:list'
            && e !== 'users_son:list'
            && e !== 'agente:list'
            && e !== 'newletters:list',
        )
      }
      setTimeout(() => {
        this.$store.state.app.showConfiguration = !this.$store.state.app.showConfiguration
      }, 10)
    },
    checkAllEditBooking() {
      const { permisos } = this.sourcePermisos[this.index]
      this.$store.state.app.showConfiguration = false
      if (this.sourcePermisos[this.index].all.checkboxConfigurationEdit) {
        this.sourcePermisos[this.index].permisos.push('config_general:edit')
        this.sourcePermisos[this.index].permisos.push('perfil_afiliado:edit')
        this.sourcePermisos[this.index].permisos.push('user_register:edit')
        this.sourcePermisos[this.index].permisos.push('role:edit')
        this.sourcePermisos[this.index].permisos.push('user:edit')
        this.sourcePermisos[this.index].permisos.push('users_son:edit')
        this.sourcePermisos[this.index].permisos.push('agente:edit')
        this.sourcePermisos[this.index].permisos.push('newletters:edit')
      } else {
        this.sourcePermisos[this.index].permisos = permisos.filter(
          e => e !== 'config_general:edit'
            && e !== 'perfil_afiliado:edit'
            && e !== 'user_register:edit'
            && e !== 'role:edit'
            && e !== 'user:edit'
            && e !== 'users_son:edit'
            && e !== 'agente:edit'
            && e !== 'newletters:edit',
        )
      }
      setTimeout(() => {
        this.$store.state.app.showConfiguration = !this.$store.state.app.showConfiguration
      }, 10)
    },
    checkAllCreateBooking() {
      const { permisos } = this.sourcePermisos[this.index]
      this.$store.state.app.showConfiguration = false
      if (this.sourcePermisos[this.index].all.checkboxConfigurationCreate) {
        this.sourcePermisos[this.index].permisos.push('config_general:create')
        this.sourcePermisos[this.index].permisos.push('perfil_afiliado:create')
        this.sourcePermisos[this.index].permisos.push('user_register:create')
        this.sourcePermisos[this.index].permisos.push('role:create')
        this.sourcePermisos[this.index].permisos.push('user:create')
        this.sourcePermisos[this.index].permisos.push('users_son:create')
        this.sourcePermisos[this.index].permisos.push('agente:create')
        this.sourcePermisos[this.index].permisos.push('newletters:create')
      } else {
        this.sourcePermisos[this.index].permisos = permisos.filter(
          e => e !== 'config_general:create'
            && e !== 'perfil_afiliado:create'
            && e !== 'user_register:create'
            && e !== 'role:create'
            && e !== 'user:create'
            && e !== 'users_son:create'
            && e !== 'agente:create'
            && e !== 'newletters:create',
        )
      }
      setTimeout(() => {
        this.$store.state.app.showConfiguration = !this.$store.state.app.showConfiguration
      }, 10)
    },
    checkAllDestroyBooking() {
      const { permisos } = this.sourcePermisos[this.index]
      this.$store.state.app.showConfiguration = false
      if (this.sourcePermisos[this.index].all.checkboxConfigurationDelete) {
        this.sourcePermisos[this.index].permisos.push('config_general:destroy')
        this.sourcePermisos[this.index].permisos.push('perfil_afiliado:destroy')
        this.sourcePermisos[this.index].permisos.push('user_register:destroy')
        this.sourcePermisos[this.index].permisos.push('role:destroy')
        this.sourcePermisos[this.index].permisos.push('user:destroy')
        this.sourcePermisos[this.index].permisos.push('users_son:destroy')
        this.sourcePermisos[this.index].permisos.push('agente:destroy')
        this.sourcePermisos[this.index].permisos.push('newletters:destroy')
      } else {
        this.sourcePermisos[this.index].permisos = permisos.filter(
          e => e !== 'config_general:destroy'
            && e !== 'perfil_afiliado:destroy'
            && e !== 'user_register:destroy'
            && e !== 'role:destroy'
            && e !== 'user:destroy'
            && e !== 'users_son:destroy'
            && e !== 'agente:destroy'
            && e !== 'newletters:destroy',
        )
      }
      setTimeout(() => {
        this.$store.state.app.showConfiguration = !this.$store.state.app.showConfiguration
      }, 10)
    },
  },
}
</script>
